export default "__VITE_PUBLIC_ASSET__2af1983a__"